export const READ_ERROR = "Something went wrong reading that file. Try another one?"

// A message that is safe to show the visitor as-is.
export class SourceError extends Error {
  name = "SourceError"
}
